import React from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import LinkedInLogo from '../../assets/svg/linkedin-logo-square.svg'
import Button from '../Button'
import Img from 'gatsby-image'

const StyledContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;

	${({ theme }) => theme.media.desktop} {
		flex-wrap: nowrap;
	}
`

const StyledLeftColumn = styled.div`
  -ms-flex: 0 0 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  justify-content: space-between;
  max-width: 100%;
  padding: 36px 0;
  position: relative;

  ${({ theme }) => theme.media.desktop} {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 46.666667%;
    max-width: 46.666667%;
  }
  svg {
    path {
      fill: #000;
    }
  }

  h1 {
    color: #0a1f44;
    font-size: 1.725em;
    font-weight: 300;
    line-height: 1.41;
    margin-bottom: 16px;
    padding: 0 16px;
    text-align: center;

    ${({ theme }) => theme.media.desktop} {
      font-size: 2.125em;
      margin-bottom: 0px;
    }
  }
`

const StyledRightColumn = styled.div`
	-ms-flex: 0 0 100%;
	flex: 0 0 100%;
	max-width: 100%;
	position: relative;

	img {
		max-width: 100%;
  }
  
	${({ theme }) => theme.media.desktop} {
		-ms-flex: 0 0 36.333333%;
		flex: 0 0 36.333333%;
		max-width: 36.333333%;
	}
`

const StyledAuthorData = styled.div`
  align-items: flex-end;
	background-image: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0),
		rgba(0, 0, 0, 0.01) 8%,
		rgba(0, 0, 0, 0.05) 16%,
		rgba(0, 0, 0, 0.11) 22%,
		rgba(0, 0, 0, 0.18) 59%,
		rgba(0, 0, 0, 0.26) 71%,
		rgba(0, 0, 0, 0.35) 79%,
		rgba(0, 0, 0, 0.45) 84%,
		rgba(0, 0, 0, 0.55) 92%
	);
	bottom: 0;
	display: flex;
	height: 128px;
	padding: 24px;
	width: 100%;
  border-radius: 8px;
  position: absolute;
  
	h6, p {
		color: #fff;
		font-size: 0.875em;
		font-weight: 700;
		line-height: 1.71;
  }
  
	p {
		font-weight: 500 !important;
	}
`
const StyledSVG = styled(SVG)`
	svg {
		height: 24px;
    width: 24px;
    
		path {
			fill: #fff;
		}
	}
`

const StyledIconContainer = styled.div`
	align-items: flex-end;
	display: flex;
`

const SingleQuote = ({ quote, author, cmsData }) => {
	if(cmsData){
		quote = cmsData.quote.fields
		author = cmsData.author.fields
	}
	return (
    <StyledContainer>
      <StyledLeftColumn>
        <SVG
          src={
            cmsData
              ? quote.companyLogo.fields.file.url
              : quote.companyLogo.file.url
          }
        />
        <h1>{quote.text.text || quote.text}</h1>
        <Button ghost="true" to={quote.caseStudyLink}>
          Learn from their Success
        </Button>
      </StyledLeftColumn>
      <StyledRightColumn>
        {cmsData ? (
          <img alt={author.name} loading="lazy" src={author.image.fields.file.url} />
        ) : (
          <Img fluid={author.image.fluid}/>
        )}
        <StyledAuthorData>
          <StyledContainer>
            <div>
              <h6>{author.name}</h6>
              <p>{author.position}</p>
            </div>
            <StyledIconContainer>
              <a href={author.linkedInLink}>
                <StyledSVG src={LinkedInLogo} />
              </a>
            </StyledIconContainer>
          </StyledContainer>
        </StyledAuthorData>
      </StyledRightColumn>
    </StyledContainer>
  )
}

export default SingleQuote
